<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-tipo-pedido') }}
                </h1>
            </div>
            <!-- BOTÃO DE SALVAR -->
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="fecharModal()">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="tipoPedidoSelecionados.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <!-- CAIXA DE BUSCA -->
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" />
            </div>
        </div>

        <!-- LISTAGEM -->
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="tipopedido"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="tipoPedidoSelecionados"
                :custom-is-checked="
                    (selecionados, linha) => selecionados.idtipopedido === linha.idtipopedido
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <!-- PAGINAÇÃO -->
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTipoPedidoClienteService from '@/services/vendas/cliente/abas/AssTipoPedidoClienteService';

// MENSAGENS
import Message from '@/models/Message';

export default {
    props: {
        idCliente: 0,
    },
    data() {
        return {
            service: new AssTipoPedidoClienteService(this.$http, this.$router),
            tipopedido: [],
            isLoading: false,
            isEmpty: false,
            fields: [{ key: 'tipo-pedido', width: null, sortable: true, sortFn: null }],
            tipoPedidoSelecionados: [],
            idtipopedido: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'tipo-pedido',
            order: 'asc',
            msgs: [],
            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idCliente,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.tipopedido = value;
                    this.isEmpty = this.tipopedido.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findNaoAssociados(column, order, page, limit, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findNaoAssociadosVendas(
                    column,
                    order,
                    page,
                    limit,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findNaoAssociadosAgro(
                    column,
                    order,
                    page,
                    limit,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcliente: this.idCliente,
                    idtipopedido: m.idtipopedido,
                    'tipo-pedido': m.descricao,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.tipoPedidoSelecionados.length > 0) {
                this.isLoading = true;

                this.saveTP()
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$emit('fecharModal', true);
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-tipo-pedido', true));
                this.isLoading = false;
            }
        },
        saveTP() {
            if (this.isVenda) return this.service.saveVendas(this.tipoPedidoSelecionados);
            else return this.service.saveAgro(this.tipoPedidoSelecionados);
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
